import LogRocket from 'logrocket';
import { parseJwt } from '../helpers/parseJwt';

const getAppId = () =>
  import.meta.env.VITE_LOGROCKET_APP_ID as string | undefined;

let initialized = false;

export function initLogRocket() {
  if (initialized) return;
  const appId = getAppId();
  if (!appId) return;
  try {
    LogRocket.init(appId);
    initialized = true;
  } catch {
    return;
  }
}

export function identifyFromToken(token: string | null | undefined) {
  if (!token) return;
  initLogRocket();
  if (!initialized) return;
  try {
    const payloadUnknown = parseJwt(token) as unknown;
    if (!payloadUnknown || typeof payloadUnknown !== 'object') return;
    const payload = payloadUnknown as Record<string, unknown>;
    const user = payload.sub ? String(payload.sub) : 'unknown';
    const traits: Record<string, string | number | boolean> = {};
    if (typeof user === 'string' && user) traits.name = user;
    LogRocket.identify(user, traits);
  } catch {
    return;
  }
}

export type TrackProps = Record<
  string,
  string | number | boolean | string[] | number[] | boolean[] | null | undefined
>;
